<div class="text-center">
  <img src="./assets/Images/Logo2.svg" alt="Logo">
</div>
<div class="mobile-responsive">
<div style="margin-top: 8rem;" class="card col-lg-3 col-11 mx-auto">
  <div class="card-body">
    <div class="text-center">
        <span class="icon-check-circle"></span>
    <h4 style="margin-top: 2.5rem;">Registrierung abgeschlossen</h4>
    <small>
      Ihr Konto wurde erfolgreich erstellt. Jetzt können Sie sich mit Ihrem neuen Konto anmelden.
    </small>
  </div>
    <button type="button" class="btn btn-primary d-block mx-auto submit-button" (click)="GoToLogin()">Anmeldung</button>
  </div>
</div>
</div>
<div class="text-center link mt-md-4">
  <a [href]="'https://www.ing-plus.de/datenschutz'" target="_blank" class="link-btn no-decoration">Datenschutzerklärung</a> <span class="link-btn"> |</span> 
  <a [href]="'https://www.ing-plus.de/impressum'" target="_blank" class="link-btn no-decoration ml-1">Impressum</a>
</div>

